/*
  get incident flow
  There's a lot of logic in relationships so we've broken them out into different flows so relationships-modal doesn't get too crowded
*/
import { defaultFieldLogic } from 'AppSrc/core/components/forms/form-base-components/data-structure/default-field-logic';
import {
  RT_PROJECT_CODE,
} from 'AppSrc/core/components/forms/value-dependency-constants';
import { projectCode } from './project-code';

const getProjectFlow = (params = {}) => {
  const {
    relationshipTypeValue,
    // values,
    // formData,
    // touched,
    // userRoles,
    // sectionId,
    // // the form that exists outside of the modal form
    // outerFormData,
  } = params;


  const shouldRender = relationshipTypeValue === RT_PROJECT_CODE;


  const currentFields = [];

  currentFields.push({
    ...defaultFieldLogic,
    componentData: projectCode,


    shouldRender,
    shouldValidate: shouldRender,
    overwriteSubmit: {
      overwrite: !shouldRender,
      overwriteValue: null,
    },
  });

  return currentFields;
};

export {
  getProjectFlow,
};



